<template>
    <div class="row">
<!--        <div class="col-md-6 col-12">-->
<!--            <a :class="'btn btn-lg d-block ' + colorClass" href="/account/trial" role="button">-->
<!--                <i :class="'fa-solid fa-chevron-right me-2'"></i> Proefweek-->
<!--            </a>-->
<!--        </div>-->
        <div class="col-md col-12 mt-2 mt-md-0" v-if="showInschrijven">
            <a :class="'btn btn-lg d-block ' + colorClass" href="/abonnementen" role="button">
                <i :class="'fa-solid fa-chevron-right me-2'"></i> {{ aanmeldText }}
            </a>
        </div>
        <div class="col-md col-12 mt-2 mt-md-0">
            <a :class="'btn btn-lg d-block ' + colorClass" onclick="Calendly.initPopupWidget({url: 'https://calendly.com/private-gym/rondleiding'});return false;"
               target="_blank" role="button">
                <i :class="'fa-solid fa-calendar-days me-2'"></i> {{ rondleidingText }}
            </a>
        </div>
        <div class="col-md col-12 mt-2 mt-md-0" v-if="showWhatsapp">
            <a type="button" class="btn btn-lg d-block btn-success btn-lg"
               href="https://wa.me/+31649672871?text=Ik%20zou%20graag%20wat%20meer%20informatie%20willen%20over%20Private%20Gym"
               rel="_blank">
                <i class="bi bi-whatsapp" style="margin-right: 12px;"></i><span
                style="display: inline-block;">WhatsApp</span>
            </a>
        </div>

    </div>
</template>

<script>

export default {
    components: {},

    props: {
        colored: {default: false},
        outline: {default: false},
        icon: {default: false},
        showInschrijven: {default: true},
        showWhatsapp: {default: false},
        aanmeldText: {default: 'Probeer één maand: €1'},
        rondleidingText: {default: 'Rondleiding'},
    },

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        colorClass() {
            if(this.colored) {
                if(this.outline) {
                    return 'btn-outline-dark';
                }
                return 'btn-dark';
            }

            if(this.outline) {
                return 'btn-outline-light';
            }
            return 'btn-light';
        },
        marginClass() {
            if(this.icon) {
                return 'me-2';
            }
            return '';
        }
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
